import {Icon} from 'front-onceforall-core';
import {mandateWebsites} from 'front-onceforall-core/dist/utils/mandates';
import PropTypes from 'prop-types';
import {Translate} from 'react-redux-i18n';
import Field from './field';
import {pathResolver} from '../../../../utils/basePathHelper';

function Information({details, isCollectionMandate}) {
  const websiteKey = details.thirdPartyGroup || details.subtypeCode || details.platform;
  const website = mandateWebsites[websiteKey];
  return (
    <div className="card">
      <div className="card-header">
        <div className="card-title">
          <Translate value={`mandate.details.information.${isCollectionMandate ? 'collection' : 'broadcast'}`}/>
        </div>
      </div>
      <div className="row">
        <div className={website ? 'col-6' : 'col-12'}>
          {details.fieldsValues.map((field, index, fields) => (
            <Field
              key={`mandate-field-${field.key}`}
              field={field}
              isLast={index === fields.length - 1}
            />
          ))}
        </div>
        {website &&
          <div className="col-6">
            <div
              className="ml-5 pl-5"
              style={{borderLeft: '1px solid #eee'}}
            >
              <h3>
                <Translate value="mandate.details.information.website"/>
              </h3>
              <div className="flex-container active font-size-s mb-3">
                <Icon
                  icon="new-tab"
                  size={16}
                />
                <a
                  href={website}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Translate value={`mandate.${isCollectionMandate ? 'thirdPartyWebsite' : 'platformWebsite'}`}/>
                </a>
              </div>
              <div className="mt-3">
                <img
                  src={pathResolver(`resources/mandateWebsitePreviews/${websiteKey}.png`)}
                  style={{width: '100%', maxWidth: 500}}
                />
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  );
}

Information.propTypes = {
  details: PropTypes.object.isRequired,
  isCollectionMandate: PropTypes.bool.isRequired
};

export default Information;
